import React from "react";
import { api } from "@/utils/api";
import i18n from "i18next";
import { getWindow } from "ssr-window";
import { connect } from "react-redux";

import ContainerNavs from "@/react-components/ContainerNavs";
import SearchBar from "@/react-components/SearchBar";
import BackButton from "@/react-components/BackButton";
import SearchResult from "@/react-components/SearchResult";
import ReactSlot from "@/react-components/ReactSlot";
import {
  isMiniSize as isMiniSizeMethod,
  debounce,
  setUrlParameter,
  parse,
} from "@/utils";
import url from "@/utils/url";
import config from "@/utils/config";
import { urlFromEnum } from "../../utils/enum";

class HomeCrossSearchSection extends React.Component {
  constructor(props) {
    super(props);

    this.navList = config.crossSearchNavList(props.bmServiceStatus);

    this.original = {
      searchParams: {
        catagoryid: this.navList[0].catagoryid,
        pageNo: 1,
        pageSize: 10,
        totalPage: 1,
        keyWord: "",
      },
      articles: null,
    };
    this.newAction = false;
    this.prevPropsTarget = null;
    this.state = {
      ...JSON.parse(JSON.stringify(this.original)),
      isMiniSize: false,
    };

    this.reactSlotRef = React.createRef();
    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.resize();
    getWindow().addEventListener("resize", this.resizeDebounce);
    this.fetchParams();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.bmServiceStatus !== this.props?.bmServiceStatus) {
      const { searchParams } = this.state;
      this.navList = config.crossSearchNavList(this.props?.bmServiceStatus);
      this.setState({
        searchParams: {
          ...searchParams,
          catagoryid: this.navList[0].catagoryid,
        },
      });
    }
    this.prevPropsTarget = prevProps;
  }

  componentWillUnmount() {
    getWindow().removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props?.router?.location?.state !==
        nextProps?.router?.location?.state &&
      nextProps?.router?.location?.pathname === url.search
    ) {
      this.fetchParams(nextProps);
    }
  }

  fetchData = () => {
    const { searchParams } = this.state;
    if (searchParams.catagoryid === "businessMatching" && this.newAction) {
      this.newAction = false;

      const prevCurrentPage =
        parse("page", this.prevPropsTarget?.router?.location?.search) || "1";
      const currentPage =
        parse("page", this.props?.router?.location?.search) || "1";
      if (prevCurrentPage === currentPage) {
        this.reactSlotRef && this.reactSlotRef.current.dispatchEventDebounce();
      }
    } else if (searchParams.catagoryid !== "businessMatching") {
      api.home
        .search({
          pageindex: searchParams.pageNo,
          pagesize: searchParams.pageSize,
          keyWord: searchParams.keyWord,
          type: searchParams.catagoryid,
        })
        .then((response) => {
          searchParams.totalPage = parseInt(
            (response.totalCount + searchParams.pageSize - 1) /
              searchParams.pageSize
          );
          this.setState({
            searchParams,
            articles: response.list.map((item) => ({
              ...item,
              link: `${item.link}${
                item.link.indexOf("?") === -1 ? "?" : "&"
              }from=${urlFromEnum.search}`,
            })),
          });
          if (response.list.length === 0) {
            setUrlParameter({ type: "noResult" });
          } else {
            setUrlParameter({
              type:
                searchParams.catagoryid === "report"
                  ? "research"
                  : searchParams.catagoryid,
              page: searchParams.pageNo,
            });
          }
        })
        .catch((error) => {
          console.error("error: " + error.message);
        });
    }
  };

  search = (keyWord) => {
    const { searchParams } = JSON.parse(JSON.stringify(this.original));
    searchParams.keyWord = keyWord;
    this.go(searchParams);
  };

  navChange = (catagoryid) => {
    if (
      this.state.searchParams.catagoryid === catagoryid &&
      catagoryid === "businessMatching"
    ) {
      this.newAction = true;
    }
    const {
      searchParams: { keyWord },
    } = this.state;
    const { searchParams } = JSON.parse(JSON.stringify(this.original));
    searchParams.keyWord = keyWord;
    searchParams.catagoryid = catagoryid;
    this.go(searchParams);
  };

  pageChange = (page) => {
    const { searchParams } = this.state;
    searchParams.pageNo = page;
    this.go(searchParams);
  };

  resize = () => {
    this.setState({
      isMiniSize: isMiniSizeMethod(),
    });
  };

  go = (params) => {
    const {
      router: {
        history: { push },
      },
    } = this.props;
    push({
      pathname: url.search,
      state: { params: JSON.parse(JSON.stringify(params)) },
    });
  };

  fetchParams = (props = this.props) => {
    const {
      router: {
        location: { state },
      },
    } = props;
    const original = JSON.parse(JSON.stringify(this.original));
    if (state) {
      let params;
      if (state?.keyWord) {
        const { searchParams } = original;
        params = {
          ...searchParams,
          keyWord: state?.keyWord,
        };
      } else if (state?.params) {
        params = state?.params;
      }
      this.setState({ searchParams: params }, () => {
        this.fetchData();
      });
    } else {
      this.setState(original);
    }
  };

  render() {
    const {
      articles,
      searchParams: { totalPage, keyWord, pageNo, catagoryid },
      isMiniSize,
    } = this.state;
    const activeIndex = this.navList
      .map((item) => item.catagoryid)
      .indexOf(catagoryid);
    const currentPage =
      parse("page", this.props?.router?.location?.search) || "1";
    return (
      <React.Fragment>
        {isMiniSize && <SearchBar keyword={keyWord} search={this.search} />}
        <BackButton />
        <h3 className="page-title-text home-search-result-page-title">
          {i18n.t("TCMS01003_searchResult")}
        </h3>
        <ContainerNavs
          navs={this.navList}
          activeIndex={activeIndex}
          navChange={this.navChange}
          className="home-search-navs"
        />
        {catagoryid === "businessMatching" && (
          <ReactSlot
            key={activeIndex + "_" + currentPage}
            {...this.props}
            ref={this.reactSlotRef}
          />
        )}
        {catagoryid !== "businessMatching" && articles && (
          <SearchResult
            showTitle={false}
            list={articles}
            totalPage={totalPage}
            pageIndex={pageNo}
            onChange={this.pageChange}
            keyword={keyWord}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bmServiceStatus: state?.user?.bmServiceStatus,
  };
};

export default connect(mapStateToProps)(HomeCrossSearchSection);
